export default __webpack_public_path__ + "static/media/background-elipse.8076827d.png";